import
{
    makeHandlerChainAwaitable,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import validateAddress, { AddressErrors } from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";
import { getAddressFieldsDataView } from "@insite/client-framework/Store/Data/AddressFields/AddressFieldsSelector";
import { chain,ValidateBillingAddress,ValidateShippingAddress} from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/SetInitialValues";
import cloneDeep from "lodash/cloneDeep";

// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}
replaceInChain(
    chain,
    ValidateBillingAddress,
     async props =>
{
    const state = props.getState();
    const billingAddressFormState = state.pages.onePageCheckout.billingAddressFormState;
    if (!billingAddressFormState) {
        return;
    }

    let addressFieldsDataView = getAddressFieldsDataView(state);
    if (!addressFieldsDataView.value) {
        addressFieldsDataView = getAddressFieldsDataView(state);
    }

    const awaitableValidate = makeHandlerChainAwaitable<Parameters<typeof validateAddress>[0], AddressErrors>(
        validateAddress,
    );
    if(addressFieldsDataView?.value != undefined && addressFieldsDataView?.value != null)
    {
        const billingAddressErrors = await awaitableValidate({
            address: props.billTo,
            validationRules: props.billTo?.validation!,
            addressFieldDisplayCollection: addressFieldsDataView?.value!.billToAddressFields,
        })(props.dispatch, props.getState);
        const isBillingAddressValid = Object.keys(billingAddressErrors).length === 0;
        props.dispatch({
            type: "Pages/OnePageCheckout/SetIsBillingAddressUpdateRequired",
            isBillingAddressUpdateRequired: !isBillingAddressValid,
        });
    }
  
    
},
);
replaceInChain(
    chain,
    ValidateShippingAddress,
     async props =>
{
    const state = props.getState();
    const session = state.context.session;
    if (session.fulfillmentMethod === FulfillmentMethod.PickUp) {
        return;
    }

    let addressFieldsDataView = getAddressFieldsDataView(state);
    if (!addressFieldsDataView.value) {
        addressFieldsDataView = getAddressFieldsDataView(state);
    }

    const awaitableValidate = makeHandlerChainAwaitable<Parameters<typeof validateAddress>[0], AddressErrors>(
        validateAddress,
    );
    if(addressFieldsDataView?.value != undefined && addressFieldsDataView?.value != null)
    {
    const shippingAddressErrors = await awaitableValidate({
        address: props.shipTo,
        validationRules: props.shipTo.validation!,
        addressFieldDisplayCollection: addressFieldsDataView.value!.shipToAddressFields,
    })(props.dispatch, props.getState);
    const isShippingAddressValid = Object.keys(shippingAddressErrors).length === 0;

    props.dispatch({
        type: "Pages/OnePageCheckout/SetIsShippingAddressUpdateRequired",
        isShippingAddressUpdateRequired: !isShippingAddressValid,
    });
}
},
);

